// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New blue theme for Data Architecture page (2026 standard) */
.da-root {
  --primary-50: #e9f2ff;
  --primary-100: #d0e6ff;
  --primary-300: #7fb7ff;
  --primary-500: #0077d6;
  --primary-700: #035aa6;
  --muted: #6b7280;

  background: linear-gradient(180deg, var(--primary-50) 0%, #f6fbff 100%);
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  color: #0b2540;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.da-root .MuiTypography-root {
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
}

/* Hero section */
.da-hero {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 60vh;
  background-size: cover;
  background-position: center;
  color: #fff;
  position: relative;
}
.da-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(2,48,84,0.55) 0%, rgba(0,119,214,0.18) 60%);
  pointer-events: none;
}

.hero-text {
  animation: fadeInDown 1.2s ease-in-out;
  z-index: 1;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Sections */
.da-container {
  padding-top: 64px;
  padding-bottom: 64px;
}

.da-section {
  padding: 56px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.da-source {
  background: linear-gradient(90deg, rgba(3,90,166,0.95), rgba(0,119,214,0.9));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 48vh;
  background-size: cover;
  color: #fff;
  padding-left: 0;
}

/* Headings */
.da-heading {
  margin-bottom: 18px;
  color: #042a48;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.da-subheading {
  margin-bottom: 22px;
  line-height: 1.6;
  color: var(--muted);
  font-weight: 500;
}

.white {
  color: #fff;
}

/* Cards */
.da-card {
  background: #ffffff;
  border-radius: 14px;
  transition: transform 0.28s cubic-bezier(.2,.9,.3,1), box-shadow 0.28s ease;
  box-shadow: 0 6px 14px rgba(2,48,84,0.06);
}
.da-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 40px rgba(2,48,84,0.12);
}

.da-card-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.da-step-num {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-700);
  min-width: 28px;
}

.da-step-title {
  font-size: 18px;
  font-weight: 700;
  color: #042a48;
}

.da-step-desc {
  font-size: 15px;
  color: var(--muted);
}

/* Data Quality */
.da-quality-card {
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(0,119,214,0.12), rgba(3,90,166,0.06));
  border: 1px solid rgba(3,90,166,0.06);
}
.da-quality-card:hover {
  transform: translateY(-6px);
}

/* Images */
.da-image {
  width: 100%;
  border-radius: 12px;
  animation: fadeInUp 1s ease;
  box-shadow: 0 8px 24px rgba(2,48,84,0.06);
}

.da-image-wide {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  animation: fadeInUp 1s ease;
  box-shadow: 0 10px 30px rgba(2,48,84,0.06);
}

/* Tagline */
.da-tagline {
  font-weight: 700;
  color: var(--primary-700);
  margin-top: 20px;
}

/* Animations */
.fade-in-up {
  animation: fadeInUp 1s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/segments/data-architecture/DataArchitecture.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;;EAEhB,uEAAuE;EACvE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,2FAA2F;AAC7F;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oFAAoF;EACpF,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2EAA2E;EAC3E,yCAAyC;AAC3C;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,8EAA8E;EAC9E,qCAAqC;AACvC;AACA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* New blue theme for Data Architecture page (2026 standard) */\n.da-root {\n  --primary-50: #e9f2ff;\n  --primary-100: #d0e6ff;\n  --primary-300: #7fb7ff;\n  --primary-500: #0077d6;\n  --primary-700: #035aa6;\n  --muted: #6b7280;\n\n  background: linear-gradient(180deg, var(--primary-50) 0%, #f6fbff 100%);\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n  color: #0b2540;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.da-root .MuiTypography-root {\n  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\n}\n\n/* Hero section */\n.da-hero {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 60vh;\n  background-size: cover;\n  background-position: center;\n  color: #fff;\n  position: relative;\n}\n.da-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(2,48,84,0.55) 0%, rgba(0,119,214,0.18) 60%);\n  pointer-events: none;\n}\n\n.hero-text {\n  animation: fadeInDown 1.2s ease-in-out;\n  z-index: 1;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Sections */\n.da-container {\n  padding-top: 64px;\n  padding-bottom: 64px;\n}\n\n.da-section {\n  padding: 56px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.da-source {\n  background: linear-gradient(90deg, rgba(3,90,166,0.95), rgba(0,119,214,0.9));\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 48vh;\n  background-size: cover;\n  color: #fff;\n  padding-left: 0;\n}\n\n/* Headings */\n.da-heading {\n  margin-bottom: 18px;\n  color: #042a48;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n.da-subheading {\n  margin-bottom: 22px;\n  line-height: 1.6;\n  color: var(--muted);\n  font-weight: 500;\n}\n\n.white {\n  color: #fff;\n}\n\n/* Cards */\n.da-card {\n  background: #ffffff;\n  border-radius: 14px;\n  transition: transform 0.28s cubic-bezier(.2,.9,.3,1), box-shadow 0.28s ease;\n  box-shadow: 0 6px 14px rgba(2,48,84,0.06);\n}\n.da-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 18px 40px rgba(2,48,84,0.12);\n}\n\n.da-card-content {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.da-step-num {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--primary-700);\n  min-width: 28px;\n}\n\n.da-step-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #042a48;\n}\n\n.da-step-desc {\n  font-size: 15px;\n  color: var(--muted);\n}\n\n/* Data Quality */\n.da-quality-card {\n  border-radius: 12px;\n  background: linear-gradient(135deg, rgba(0,119,214,0.12), rgba(3,90,166,0.06));\n  border: 1px solid rgba(3,90,166,0.06);\n}\n.da-quality-card:hover {\n  transform: translateY(-6px);\n}\n\n/* Images */\n.da-image {\n  width: 100%;\n  border-radius: 12px;\n  animation: fadeInUp 1s ease;\n  box-shadow: 0 8px 24px rgba(2,48,84,0.06);\n}\n\n.da-image-wide {\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 12px;\n  animation: fadeInUp 1s ease;\n  box-shadow: 0 10px 30px rgba(2,48,84,0.06);\n}\n\n/* Tagline */\n.da-tagline {\n  font-weight: 700;\n  color: var(--primary-700);\n  margin-top: 20px;\n}\n\n/* Animations */\n.fade-in-up {\n  animation: fadeInUp 1s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
